import React from "react";
import Form from 'react-bootstrap/Form'
import Accordion from 'react-bootstrap/Accordion'
const { Component } = React;

export default class CaptionsFilter extends Component {

  constructor(props) {
    super(props);
    this.changeFilter = props.changeFilter;
  }

  shouldComponentUpdate(newProps) {
    return (this.props.data !== newProps.data) || (this.props.filters !== newProps.filters);   
  }

  render() {
   return (
    <Accordion>
      { this.props.data != null && Object.keys(this.props.data).map((captionKey) => (
        <Accordion.Item key={captionKey} eventKey={captionKey}>
          <Accordion.Header>{this.props.data[captionKey].name}</Accordion.Header>
          <Accordion.Body>
            { Object.keys(this.props.data[captionKey].labels).map((labelKey) => (
    
              <Form.Check
                label={this.props.data[captionKey].labels[labelKey]}
                name="group1"
                type="checkbox"
                checked={this.props.filters.captions[captionKey] != null ? this.props.filters.captions[captionKey].includes(Number(labelKey.toString())) : false }
                id={captionKey + "-" + labelKey}
                key={captionKey + "-" + labelKey}
                onChange={(event) => this.changeFilter(captionKey,labelKey,event.target.checked)}
              />
            ))}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
    )
  }
}
